<template>
  <section class="app-container flex-row">
    <div class="side-wrapper">
      <app-sidebar/>
    </div>
    <div class="app-wrapper flex-col">
      <app-navbar/>
      <app-main/>
    </div>
  </section>
</template>

<script>
import { AppSidebar, AppMain, AppNavbar} from "./components";
export default {
  name: "Layout",
  components: {AppSidebar, AppMain, AppNavbar}
}
</script>

<style lang="scss" scoped>

  .side-wrapper {
    width: 200px;
    flex: 0 0 auto;
    z-index: 999;
  }

  .app-wrapper{
    flex: 1 1 auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue